import React, { Dispatch, useReducer } from "react";
import { MedicoAssistenteStepForm } from "../config/MedicoAssistenteStepForm";
import FormBase from "../forms/FormBase";
import Professional from "../models/Professional";
import {
  Actions,
  IMedicoAssistenteState,
  initialState,
  reducer,
  getStateFormPropertyByName,
} from "../context/reducers/MedicoAssistenteReducer";
import FormFieldAttachmentBase, {
  FieldAttachment,
} from "../forms/FormFieldAttachmentBase";
import ContextBase, { EAttachmentType } from "./ContextBase";

interface IMedicoAssistenteContextProps {
  state: IMedicoAssistenteState;
  dispatch: Dispatch<Actions>;
  nextStep: () => void;
  updateFile: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
  deleteFile: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
}

export const MedicoAssistenteContext = React.createContext({} as IMedicoAssistenteContextProps);

export function MedicoAssistenteStoreProvider(props: any) {
  const [state, dispatch] = useReducer(reducer, initialState);

  //Método responsavel por avançar as etapas e criar um profissional quando não existir um
  const nextStep = async () => {
    try {

      //Pular a etapa de guia
      if (state.CurrentStep === 1) {
        ContextBase.goToNextStepWithLoading(dispatch, [], false);
        return;
      }

      //Apresenta o ícone de loading no botão de avançar
      ContextBase.setLoading(dispatch, true);

      //Cria ou busca no state um profissional
      let localProfessional = await ContextBase.createOrGetProfessionalDefault(dispatch, state) as Professional;

      //Realiza a chamada genérica das APIs que insere ou atualiza os dados do formulário
      await ContextBase.callInsertOrUpdateApiForms(MedicoAssistenteStepForm, state, localProfessional, dispatch, (step, state) => { return getStateFormPropertyByName(step, state) });

    } catch (error) { }

  };

  //Método responsável por realizar o upload de arquivos
  const updateFile = async (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {

    const formData = new FormData();
    formData.append("eAttachmentAssistantDoctor", formField.TypeEnum.toString());
    formData.append("file", fieldAttachment.File);

    await ContextBase.updateloFile(dispatch, state.Professional, formData, fieldAttachment, name, form, EAttachmentType.MedicoAssistente);
  };

  const deleteFile = async (name: string, form: FormBase, fieldAttachment: FieldAttachment) => {
    await ContextBase.deleteFile(dispatch, fieldAttachment, name, form);
  };

  const value = { state, dispatch, nextStep, updateFile, deleteFile };

  return (
    <MedicoAssistenteContext.Provider value={value}>
      {props.children}
    </MedicoAssistenteContext.Provider>
  );
}
